import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AddInstViaSystemUserPagesData, InstPage } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addInstViaSystemUserPages = (
  data: AddInstViaSystemUserPagesData
): Promise<{ pages: InstPage[] }> => {
  return axios.post(`/meta/pages/add-new-facebook`, data);
};

type AddInstPagesOptions = {
  config?: MutationConfig<typeof addInstViaSystemUserPages>;
};

export function useAddInstViaSystemUserPages({ config = {} }: AddInstPagesOptions = {}) {
  return useMutation({
    ...config,
    onSuccess: (data) => {
      const pagesCount = data.pages.length;
      toasts.loadingToast.success(
        'add-facebook',
        pagesCount ? `Added ${pagesCount} new pages` : 'No new pages found'
      );
      queryClient.invalidateQueries(['pages']);
    },
    onError: (error: AxiosError<{ error: string }>) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-facebook', serverMessage);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-facebook', 'Adding pages...');
      config.onMutate?.(...args);
    },
    mutationFn: addInstViaSystemUserPages,
  });
}
